import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useForm } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Button,
  Grid,
  Box,
  Divider,
  FormLabel,
  Typography,
  FormHelperText,
} from "@mui/material";
import { useCallback } from "react";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  fetchTimeSlotFromCentral,
  reserveTimeSlot,
  getAppointmentCount,
} from "../../services/VendorAppointmentBook";
import {
  convertDateDashYMD,
  dateHash,
  isDateGreaterThan,
  padPO,
  convertDateDashDMY,
  getPOLatestDeliveryDate,
  getPOEarliestDeliveryDate,
} from "../../utils/jsUtils";
import { isDate } from "date-fns";
import useGlobalState from "../../Context";
import NoTimeSlotComponent from "../../common/TimeSlotNotFound";
import { appointmentConstant } from "../../utils/appointmentConstant";

const Step3 = ({
  onClickNext,
  handleBack,
  formData,
  setFormData,
  appointmentTimeSlots,
  setAppointmentTimeSlots,
  uniqueAppointmentTimeSlots,
  setUniqueAppointmentTimeSlots,
  materialTypeList,
  appointmentStore,
  setAppointmentStore,
  config,
  deliveryBookingWindow,
  siteConfig,
  listOfPO,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const appointmentDateValue = getValues("appointmentDate") ?? null;
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [timeSlotInfo, setTimeSlotInfo] = useState(null);
  const [showSlots, setShowSlots] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  console.log(formData, "step 3 fromdata");
  // const currentDate = new Date();
  // const daysAheadDate = new Date();
  // daysAheadDate.setDate(
  //   daysAheadDate?.getDate() +
  //     (config?.vendorAppointmentBookingWindow >= deliveryBookingWindow
  //       ? deliveryBookingWindow
  //       : config?.vendorAppointmentBookingWindow)
  // );
  // currentDate.setDate(currentDate.getDate() + 1);

  let currentDate = new Date();

  // Default minDate (currentDate + 1)
  let minDate = new Date(currentDate);
  minDate.setDate(currentDate.getDate() + 1);

  let maxDate = new Date(currentDate); // Initialize maxDate with today's date

  if (config?.enableVendorDeliveryDateCheck) {
    let baseDate = new Date();
    let maxBookingWindow = new Date();

    let bookingWindow = config?.vendorAppointmentBookingWindow || 60;
    baseDate.setDate(baseDate.getDate() + deliveryBookingWindow);
    maxBookingWindow.setDate(maxBookingWindow.getDate() + bookingWindow);

    // 🆕 Modify minDate and maxDate based on listOfPO
    if (Array.isArray(listOfPO) && listOfPO.length > 0) {
      let maxEarliestPODate = new Date(
        Math.max(
          ...listOfPO.map((po) => getPOEarliestDeliveryDate(po)?.getTime() || 0)
        )
      );
      let minLatestPODate = new Date(
        Math.min(
          ...listOfPO.map(
            (po) => getPOLatestDeliveryDate(po)?.getTime() || Infinity
          )
        )
      );

      let vendorMinDeliveryDays = config?.vendorMinDeliveryDate || 0;
      let vendorMaxDeliveryDays = config?.vendorMaxDeliveryDate || 0;

      // Calculate minDate
      minDate = new Date(maxEarliestPODate);
      minDate.setDate(minDate.getDate() - vendorMinDeliveryDays);

      // Calculate maxDate
      maxDate = new Date(minLatestPODate);
      maxDate.setDate(maxDate.getDate() + vendorMaxDeliveryDays);
    }

    // Ensure minDate is not in the past
    if (minDate <= currentDate) {
      minDate = new Date(currentDate);
      minDate.setDate(currentDate.getDate() + 1);
    }

    // Ensure maxDate does not exceed maxBookingWindow
    if (maxDate > maxBookingWindow) {
      maxDate = maxBookingWindow;
    }
  } else if (siteConfig?.configs?.enableVendorDeliveryDateCheck) {
    let baseDate = new Date();
    let maxBookingWindow = new Date();

    let bookingWindow = config?.vendorAppointmentBookingWindow || 60;
    baseDate.setDate(baseDate.getDate() + deliveryBookingWindow);
    maxBookingWindow.setDate(maxBookingWindow.getDate() + bookingWindow);

    if (Array.isArray(listOfPO) && listOfPO.length > 0) {
      let maxEarliestPODate = new Date(
        Math.max(
          ...listOfPO.map((po) => getPOEarliestDeliveryDate(po)?.getTime() || 0)
        )
      );
      let minLatestPODate = new Date(
        Math.min(
          ...listOfPO.map(
            (po) => getPOLatestDeliveryDate(po)?.getTime() || Infinity
          )
        )
      );

      let vendorMinDeliveryDays =
        siteConfig?.configs?.vendorMinDeliveryDate || 0;
      let vendorMaxDeliveryDays =
        siteConfig?.configs?.vendorMaxDeliveryDate || 0;

      // Calculate minDate
      minDate = new Date(maxEarliestPODate);
      minDate.setDate(minDate.getDate() - vendorMinDeliveryDays);

      // Calculate maxDate
      maxDate = new Date(minLatestPODate);
      maxDate.setDate(maxDate.getDate() + vendorMaxDeliveryDays);
    }
    // Ensure minDate is not in the past
    if (minDate <= currentDate) {
      minDate = new Date(currentDate);
      minDate.setDate(currentDate.getDate() + 1);
    }

    // Ensure maxDate does not exceed maxBookingWindow
    if (maxDate > maxBookingWindow) {
      maxDate = maxBookingWindow;
    }
  } else {
    let daysToAdd =
      (config?.vendorAppointmentBookingWindow ?? 60) >= deliveryBookingWindow
        ? deliveryBookingWindow
        : config?.vendorAppointmentBookingWindow ?? 60;

    maxDate = new Date(currentDate);
    maxDate.setTime(maxDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
  }

  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [{ userDetails }] = useGlobalState();

  useEffect(() => {
    if (config?.vendorAppointmentBookingWindow >= deliveryBookingWindow) {
      const todayDate = new Date();
      setError("appointmentDate", {
        message: `Appointment Permissible between ${convertDateDashDMY(
          minDate
        )}  to ${convertDateDashDMY(maxDate)} `,
      });
    }
    if (formData?.appointmentDate && formData?.startTime) {
      if (formData?.showSlot) {
        setShowSlots(true);
        const selectedTempSlot = appointmentTimeSlots?.find(
          (slot) => slot?.timeSlotId === formData?.selectedSlotId
        );
        setValue("appointmentDate", formData?.appointmentDate);
        setSelectedTimeSlot(selectedTempSlot);
      } else {
        setValue("appointmentDate", formData?.appointmentDate);
        setAppointmentDate(formData?.appointmentDate);
        setValue("startTime", formData?.startTime);
      }
      setTimeSlotInfo(formData?.timeSlotInfo);
    }
  }, [
    appointmentTimeSlots,
    formData?.appointmentDate,
    formData?.showSlot,
    formData?.startTime,
    formData?.selectedSlotId,
    setValue,
    formData?.timeSlotInfo,
    config?.vendorAppointmentBookingWindow,
    deliveryBookingWindow,
    showNotification,
    setError,
  ]);

  useEffect(() => {
    setAppointmentDate(appointmentDateValue || null);
  }, [setAppointmentDate, appointmentDateValue]);

  const userInfo = {
    userId: userDetails?.userParam?.userId,
  };

  const parseToTimeSlotPoParams = useCallback(
    (poParams) => {
      return poParams.map((object) => {
        return {
          poNumber: object?.poNumber,
          noOfCases: object?.noOfCases,
          countOfSkus: object?.countOfSkus,
          materialTypeParams: [
            {
              materialTypeId: object?.materialTypeId,
              materialType:
                materialTypeList?.find(
                  (obj) =>
                    obj.materialTypeId === parseInt(object?.materialTypeId)
                )?.materialType ?? "",
            },
          ],
        };
      });
    },
    [materialTypeList]
  );

  const selectTimeSlot = (slot, uniqueAppointmentTimeSlots) => {
    slot.isReserved = 1;
    setTimeSlotInfo(slot);
    setSelectedTimeSlot(slot);
    uniqueAppointmentTimeSlots.forEach((element, index) => {
      if (element.timeSlotId !== slot.timeSlotId) {
        element.isReserved = 0;
      }
    });
  };

  const errorStyles = {
    color: "orange", // Change the color to your desired color
    fontSize: "13px", // Optionally adjust font size
    // Add any other styles as needed
  };

  const checkEqualTimeSlot = (appointmentTimeSlots, timeSlotInfo) => {
    var timeSlotList = appointmentTimeSlots.filter(function (element) {
      return timeSlotInfo.timeSlot === element.timeSlot;
    });
    return timeSlotList;
  };

  const formatTime = (timeString) => {
    if (!timeString) return "-"; // Return a hyphen if timeString is null or undefined

    const [hours, minutes] = timeString.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
  };

  const isBookingConfigCheck = (config, date) => {
    let parms = date.split(/[\.\-T\/]/);
    let yyyy = parseInt(parms[0], 10);
    let mm = parseInt(parms[1], 10);
    let dd = parseInt(parms[2], 10);

    const configData = config?.vendorBookAppointmentCutOffTime;
    let TimeParms = configData.split(":");
    let hour = parseInt(TimeParms[0], 10);
    let mint = parseInt(TimeParms[1], 10);
    let sec = parseInt(TimeParms[2], 10);

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(yyyy, mm - 1, dd);
    const secondDate = new Date();

    const diffDays = Math.round((firstDate - secondDate) / oneDay) + 1;

    if (diffDays > 1) {
      return true;
    } else if (diffDays === 1) {
      var now = new Date();
      var nowTime = new Date(
        now.getMonth() +
          1 +
          "/" +
          now.getDate() +
          "/" +
          now.getFullYear() +
          " " +
          now.getHours() +
          ":" +
          now.getMinutes()
      );
      var userTime = new Date(
        now.getMonth() +
          1 +
          "/" +
          now.getDate() +
          "/" +
          now.getFullYear() +
          " " +
          hour +
          ":" +
          mint +
          ":" +
          sec
      );
      if (nowTime.getTime() >= userTime.getTime()) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  function getTimeslotFetchRequestBody(
    formData,
    date,
    userInfo,
    parseToTimeSlotPoParams
  ) {
    return {
      fcCode: formData?.fcCode,
      appointmentDate: convertDateDashYMD(date),
      vendorCode: padPO(formData?.vendorCode),
      vendorName: formData?.vendorName,
      vendorUserId: formData?.vendorUserId,
      parentSiteCode: formData?.parentSiteCode,
      poParams: parseToTimeSlotPoParams(formData?.poDetails),
    };
  }

  function getRequestBodyForFetchTimeSlots(
    formData,
    date,
    userInfo,
    groupedData
  ) {
    return {
      fcCode: formData?.fcCode,
      appointmentDate: convertDateDashYMD(date),
      vendorCode: padPO(formData?.vendorCode),
      vendorName: formData?.vendorName,
      vendorUserId: formData?.vendorUserId,
      parentSiteCode: formData?.parentSiteCode,
      poParams: groupedData,
    };
  }

  function iterateArticleData(groupedData, item, prepareArticleData, found) {
    for (const entry of groupedData) {
      // If the PO number already exists, add the article to its existing articles array
      if (entry.poNumber === item.poNumber) {
        prepareArticleData(entry, item);
        found = true;
        break;
      }
    }
    return found;
  }

  function prepareArticleData(entry, item) {
    entry.articleParams.push({
      articleCode: item.articleCode,
      articleName: item.articleName,
      articleBoxQuantity: Number(item.articleBoxQuantity),
      articleQuantity: item.articleQuantity,
      eanNumber: item.eanNumber,
      familyCode: item.familyCode,
      familyName: item.familyName,
      deliveryDate: item.deliveryDate,
    });
  }

  function addNewArticleEntry(found, groupedData, item) {
    if (!found) {
      groupedData.push({
        poNumber: item.poNumber.toString(),
        articleParams: [
          {
            articleCode: item.articleCode,
            articleName: item.articleName,
            articleBoxQuantity: Number(item.articleBoxQuantity),
            articleQuantity: item.articleQuantity,
            eanNumber: item.eanNumber,
            familyCode: item.familyCode,
            familyName: item.familyName,
            deliveryDate: item.deliveryDate,
          },
        ],
      });
    }
  }

  const handleTimeSlot = useCallback(
    async (date) => {
      try {
        setLoading(true);
        let timeSlotResponse = null;
        setUniqueAppointmentTimeSlots([]);
        if (
          dateHash(date) in appointmentStore &&
          appointmentStore[dateHash(date)]?.expiration > new Date()
        ) {
          timeSlotResponse = appointmentStore[dateHash(date)];
        } else {
          const getCountRequestBody = {
            fcCode: formData?.fcCode,
            appointmentDate: convertDateDashYMD(date),
            vendorCode: padPO(formData?.vendorCode),
          };
          const appointmentCountResponse = await getAppointmentCount(
            baseUrl,
            getCountRequestBody
          );
          if (appointmentCountResponse?.allowNewAppointment) {
            if (formData?.strategy === appointmentConstant.TOTAL_BOX_COUNT) {
              const requestBody = getTimeslotFetchRequestBody(
                formData,
                date,
                userInfo,
                parseToTimeSlotPoParams
              );
              timeSlotResponse = {
                ...(await fetchTimeSlotFromCentral(baseUrl, requestBody)),
                newFetch: true,
              };
            } else {
              const groupedData = [];

              formData?.selectedArticles.forEach((item) => {
                // Flag to check if the PO number already exists
                let found = false;

                // Iterate over each entry in the grouped data array
                found = iterateArticleData(
                  groupedData,
                  item,
                  prepareArticleData,
                  found
                );

                // If the PO number doesn't exist, add a new entry
                addNewArticleEntry(found, groupedData, item);
              });

              const requestBody = getRequestBodyForFetchTimeSlots(
                formData,
                date,
                userInfo,
                groupedData
              );
              timeSlotResponse = {
                ...(await fetchTimeSlotFromCentral(baseUrl, requestBody)),
                newFetch: true,
              };
            }

            // const requestBody = {
            //   fcCode: formData?.fcCode,
            //   parentSiteCode: formData?.parentSiteCode,
            //   appointmentDate: convertDateDashYMD(date),
            //   vendorCode: padPO(formData?.vendorCode),
            //   vendorName: formData?.vendorName,
            //   vendorUserId: formData?.vendorUserId,
            //   poParams: parseToTimeSlotPoParams(formData?.poDetails),
            // };

            // Check booking config
            if (isBookingConfigCheck(config, convertDateDashYMD(date))) {
              // timeSlotResponse = await fetchTimeSlotFromCentral(
              //   baseUrl,
              //   requestBody
              // );
              if (timeSlotResponse?.messageCode === 6) {
                clearErrors("startTime");
                let currentTime = new Date();
                currentTime.setTime(currentTime?.getTime() + 5 * 60 * 1000);
                setAppointmentStore({
                  ...appointmentStore,
                  [dateHash(date)]: {
                    ...timeSlotResponse,
                    expiration: currentTime,
                  },
                });
                if (!!timeSlotResponse?.timeSlotParam) {
                  const timeSlotParam = timeSlotResponse?.timeSlotParam;
                  setValue("appointmentDate", date);
                  setAppointmentDate(date);
                  setValue("startTime", timeSlotParam?.timeSlot);
                  setValue("endTime", timeSlotParam?.slotEndTime);
                  setTimeSlotInfo(timeSlotParam);
                  setShowSlots(false);
                } else {
                  setShowSlots(true);
                  setAppointmentTimeSlots(timeSlotResponse?.timeSlotParams[0]);
                  const key = "timeSlot";
                  const unique = [
                    ...new Map(
                      timeSlotResponse?.timeSlotParams[0]?.map((item) => [
                        item[key],
                        item,
                      ])
                    ).values(),
                  ];
                  const sortedData = unique.sort((a, b) => {
                    const timeA = a.timeSlot.split(":").map(Number); // Convert time to an array of numbers [hours, minutes]
                    const timeB = b.timeSlot.split(":").map(Number);

                    // Compare hours first, if equal then compare minutes
                    if (timeA[0] !== timeB[0]) {
                      return timeA[0] - timeB[0]; // Compare hours
                    } else {
                      return timeA[1] - timeB[1]; // Compare minutes if hours are equal
                    }
                  });

                  setUniqueAppointmentTimeSlots(sortedData);
                }
              } else {
                setValue("startTime", null);
                setValue("endTime", null);
                showNotification(
                  "Error",
                  timeSlotResponse?.message ??
                    "Failed To Fetch Time Slot For The Selected Date"
                );
              }
            } else {
              setError("appointmentDate", {
                message: `Appointment booking is allowed only before  ${formatTime(
                  config?.vendorBookAppointmentCutOffTime
                )} for next day appointment on Site Code ${formData?.fcCode}.`,
              });
              showNotification(
                "Warning",
                "Appointment booking is allowed only before " +
                  config?.vendorBookAppointmentCutOffTime +
                  " for next day appointment",
                "warning"
              );
            }
          } else {
            setError("appointmentDate", {
              message: `Maximum of ${appointmentCountResponse?.appointmentCount} appointments per day is permitted for a Site Code ${formData?.fcCode}.`,
            });
            timeSlotResponse = {
              messageCode: 12,
              message: `Maximum of ${appointmentCountResponse?.appointmentCount} appointments per day is permitted for a Site Code ${formData?.fcCode}.`,
            };
          }
        }
      } catch (err) {
        showNotification(
          "Error",
          err?.message ?? "Failed To Fetch Time Slot For The Selected Date"
        );
      } finally {
        setLoading(false);
      }
    },
    [
      appointmentStore,
      baseUrl,
      clearErrors,
      config,
      formData?.fcCode,
      formData?.parentSiteCode,
      formData?.poDetails,
      formData?.vendorCode,
      formData?.vendorName,
      formData?.vendorUserId,
      parseToTimeSlotPoParams,
      setAppointmentStore,
      setAppointmentTimeSlots,
      setError,
      setLoading,
      setUniqueAppointmentTimeSlots,
      setValue,
      showNotification,
    ]
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      let timeSlotResponse = null;
      var timeSlotList = checkEqualTimeSlot(appointmentTimeSlots, timeSlotInfo);
      const requestBody = {
        timeSlotList: timeSlotList,
        fcCode: formData?.fcCode,
        appointmentDate: convertDateDashYMD(selectedTimeSlot?.fcDate),
        vendorCode: padPO(formData?.vendorCode),
        vendorName: formData?.vendorName,
        vendorUserId: userInfo?.userId,
        poParams: parseToTimeSlotPoParams(formData?.poDetails),
      };
      timeSlotResponse = await reserveTimeSlot(baseUrl, requestBody);
      if (timeSlotResponse?.messageCode === 6) {
        if (showSlots) {
          const appointDateArr = selectedTimeSlot?.fcDate.split("-");
          setFormData({
            ...formData,
            appointmentDate: new Date(
              appointDateArr?.[0],
              appointDateArr?.[1] - 1,
              appointDateArr?.[2]
            ),
            startTime: selectedTimeSlot?.timeSlot,
            endTime: selectedTimeSlot?.slotEndTime,
            showSlot: true,
            timeSlotInfo: timeSlotInfo,
            timeSlotRefId: timeSlotResponse?.timeSlotParam?.timeSlotId,
            dockId: timeSlotResponse?.timeSlotParam?.dockId,
          });
        } else {
          setFormData({
            ...formData,
            ...data,
            showSlot: false,
            timeSlotInfo: timeSlotInfo,
            timeSlotRefId: timeSlotResponse?.timeSlotParam?.timeSlotId,
            dockId: timeSlotInfo?.dockId,
          });
        }
        onClickNext();
      } else {
        showNotification(
          "Error",
          timeSlotResponse?.message ??
            "Failed To Reserve Time Slot For The Selected Date"
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed To Reserve Time Slot For The Selected Date"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    register("appointmentDate", { required: true });
  }, [register]);

  return (
    <>
      <Grid className="bg-white">
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 4 }}>
            <Box sx={{ mt: 3 }}>
              <form>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  {setAppointmentDateRenderComponent(
                    minDate,
                    maxDate,
                    appointmentDateValue,
                    setValue,
                    handleTimeSlot,
                    showNotification,
                    errors,
                    errorStyles
                  )}
                  {showSlots
                    ? slotRenderComponent(
                        uniqueAppointmentTimeSlots,
                        selectTimeSlot,
                        formatTime,
                        errors
                      )
                    : noSlotRenderComponent(appointmentDate)}
                </Grid>
              </form>
            </Box>
          </Grid>
          <React.Fragment>
            <Divider />
            <Box sx={{ display: "flex", flexDirection: "row", p: 2 }}>
              <Button
                variant="outlined"
                // disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                sx={{ mr: 1 }}
                variant="outlined"
              >
                Next
              </Button>
            </Box>
          </React.Fragment>
        </Grid>
      </Grid>
    </>
  );
};
export default Step3;

function setAppointmentDateRenderComponent(
  minDate,
  maxDate,
  appointmentDateValue,
  setValue,
  handleTimeSlot,
  showNotification,
  errors,
  errorStyles
) {
  return (
    <Grid item xs={12} sm={12} md={12}>
      <FormLabel
        required={true}
        className="stepperFormLabel"
        sx={{
          width: "220px",
          marginTop: "10px",
          marginBottom: "10px",
          // display: "block", // Ensure the FormLabel takes up full width
          // textAlign: "center", // Center-align the FormLabel text
        }}
      >
        Appointment Date
      </FormLabel>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          minDate={minDate}
          maxDate={maxDate}
          value={appointmentDateValue}
          name="appointmentDate"
          onChange={async (date) => {
            if (
              isDate(date) &&
              isDateGreaterThan(maxDate, date) &&
              isDateGreaterThan(date, minDate)
            ) {
              setValue("appointmentDate", date, {
                shouldValidate: true,
                shouldDirty: true,
              });
              await handleTimeSlot(date);
            } else {
              setValue("startTime", null);
              setValue("endTime", null);
              showNotification(
                "Error",
                "Booking For Selected Date Is Not Available"
              );
            }
          }}
          inputFormat="dd/MM/yyyy"
          sx={{ pl: 1, pt: 1 }}
          renderInput={(params) => (
            <TextField
              className="stepperFormInput4"
              name="appointmentDate"
              fullWidth
              required
              type="date"
              size="small"
              autoComplete="off"
              {...params}
              sx={{ width: "35%" }}
            />
          )}
        />
      </LocalizationProvider>
      <br></br>
      {Boolean(errors?.appointmentDate) && (
        <>
          <Box display="flex" justifyContent={"center"} sx={{ ml: 25 }}>
            <FormHelperText error style={errorStyles}>
              {errors?.appointmentDate
                ? errors?.appointmentDate?.message ?? "This field is required"
                : ""}
            </FormHelperText>
          </Box>
        </>
      )}
    </Grid>
  );
}

function noSlotRenderComponent(appointmentDate) {
  return (
    !!appointmentDate && (
      <Grid item xs={12} sm={12}>
        <Typography variant="body1" fontWeight={500} textAlign="left">
          <NoTimeSlotComponent />
        </Typography>
      </Grid>
    )
  );
}

function slotRenderComponent(
  uniqueAppointmentTimeSlots,
  selectTimeSlot,
  formatTime,
  errors
) {
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        container
        spacing={2}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={6} sm={6} textAlign="center">
          Select Time Slot
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        container
        spacing={2}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          container
          spacing={{ xs: 2, md: 1 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {uniqueAppointmentTimeSlots?.map((slot, i) => {
            return (
              <Grid item xs={2} sm={1} md={1} sx={{ marginTop: "20px;" }}>
                <Button
                  variant={slot.isReserved === 1 ? "contained" : "outlined"}
                  color="primary"
                  onClick={() => {
                    selectTimeSlot(slot, uniqueAppointmentTimeSlots);
                  }}
                >
                  {formatTime(slot?.timeSlot)}
                </Button>
              </Grid>
            );
          })}
        </Grid>
        {Boolean(errors?.startTime) && (
          <FormHelperText error>
            {errors?.startTime ? "This field is required" : ""}
          </FormHelperText>
        )}
      </Grid>
    </>
  );
}
